import { MondayGateway } from './monday-gateway.interface';

const baseUrl = 'gk/monday';
export class HttpMondayGateway implements MondayGateway {
  getAllMondayBoard() {
    return {
      url: `${baseUrl}`,
      method: 'GET',
    };
  }

  postMondayBoard(args: { name: string; boardId: string }) {
    return {
      url: `${baseUrl}`,
      method: 'POST',
      data: args,
    };
  }

  updateMondayBoard(args: {
    mondayBoardId: string;
    data: { name: string; boardId: string };
  }) {
    return {
      url: `${baseUrl}/${args.mondayBoardId}`,
      method: 'PATCH',
      data: args.data,
    };
  }

  deleteMondayBoard(args: { mondayBoardId: string }) {
    return {
      url: `${baseUrl}/${args.mondayBoardId}`,
      method: 'DELETE',
    };
  }
}
